class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.onClickHandler = this.onClickHandler.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  connectedCallback() {
    // Check if the mode is click or load
    const mode = this.getAttribute('mode') || 'on-click'; 

    if (mode === 'on-click') {
      this.addEventListener('click', this.onClickHandler);
      this.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          this.onClickHandler();
        }
      });
    } else if (mode === 'on-load') {
      this.observer = new IntersectionObserver(this.handleIntersection, {
        root: null,
        rootMargin: '400px 0px 400px 0px',
        threshold: 0.01,
      });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    const mode = this.getAttribute('mode') || 'on-click';

    if (mode === 'on-click') {
      this.removeEventListener('click', this.onClickHandler);
    } else if (mode === 'on-load') {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) {
      return; // Prevent multiple triggers
    }

    this.classList.add('loading', 'disabled');

    const url = this.dataset.url;
    if (url) {
      InfiniteScroll.renderSectionFetch(url).finally(() => {
        this.classList.remove('loading', 'disabled');
      });
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.classList.contains('loading') && !this.classList.contains('disabled')) {
        this.onClickHandler();
      }
    });
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-card-container').dataset.id,
      }
    ];
  }

  static renderSectionFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        InfiniteScroll.renderPagination(responseText);
        InfiniteScroll.renderProductGridContainer(responseText);
      })
      .catch(e => {
        console.error(e);
      });
  }

  static renderPagination(html) {
    const resultContainer = document.getElementById('result-products-container');
    const container = resultContainer ? resultContainer.querySelector('.pagination-wrapper') : null;
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('result-products-container')?.querySelector('.pagination-wrapper');
    const productGrid = document.getElementById('product-card-container');

    if (container) {
      if (pagination && pagination.querySelector('infinite-scroll, a')) {
        container.innerHTML = pagination.innerHTML;
        if (productGrid) {
          productGrid.classList.add('has-more-pages');
        }
      } else {
        container.remove();
        if (productGrid) {
          productGrid.classList.remove('has-more-pages');
        }
      }
    } else {
      if (productGrid) {
        productGrid.classList.remove('has-more-pages');
      }
    }
  }

  static renderProductGridContainer(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const currentContainer = document.getElementById('product-card-container');
    const newContainer = doc.getElementById('product-card-container');

    if (currentContainer && newContainer) {
      const newCards = Array.from(newContainer.children);
      const newInStock = [];
      const newOutOfStock = [];

      newCards.forEach(card => {
        const isAvail = card.getAttribute('data-available');
        const hasSoldBadge = card.querySelector('.badge-sold, .badge-soldout, [id*="soldout"], .out-of-stock');
        if (isAvail === 'false' || (isAvail !== 'true' && hasSoldBadge)) {
          newOutOfStock.push(card);
        } else {
          newInStock.push(card);
        }
      });

      // Find the first out-of-stock card in the existing grid
      const firstOutOfStockCard = Array.from(currentContainer.children).find(card => {
        const isAvail = card.getAttribute('data-available');
        const hasSoldBadge = card.querySelector('.badge-sold, .badge-soldout, [id*="soldout"], .out-of-stock');
        return isAvail === 'false' || (isAvail !== 'true' && hasSoldBadge);
      });

      // Insert incoming in-stock cards before any out-of-stock cards
      newInStock.forEach(card => {
        if (firstOutOfStockCard) {
          currentContainer.insertBefore(card, firstOutOfStockCard);
        } else {
          currentContainer.appendChild(card);
        }
      });

      // Append incoming out-of-stock cards at the very end
      newOutOfStock.forEach(card => {
        currentContainer.appendChild(card);
      });
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);



